import { Document } from '@contentful/rich-text-types';
import React, { useEffect } from 'react';
import { Redirect } from 'react-router';
import styled from 'styled-components';
import { FiveStarSurvey } from '../../../../components/FiveStarSurvey';
import RichText from '../../../../components/RichText';
import { RefundsDescription, RefundsSeparator } from '../../components/CommonComponents';
import { PageContainer } from '../../styles';
import { getUrl } from '../../utils';
import InvoiceIcon from './InvoiceIcon';
import RefundSection, { RefundSectionProps } from './RefundSection';

const s = {
  PageContainer: styled(PageContainer)`
    max-width: 482px;
    text-align: center;
  `,
  Icon: styled(InvoiceIcon)`
    width: 60px;
    height: 60px;
  `,
};

const RefundGuidePage = () => {
  const redirect = () => <Redirect to={getUrl('warranty-selection')} />;

  const selectedServicesStr = sessionStorage.getItem('selected-refund-services');
  const descriptionStr = sessionStorage.getItem('refund-description');
  if (!selectedServicesStr || !descriptionStr) {
    return redirect();
  }

  let selectedServices: RefundSectionProps[];
  let description: Document;

  try {
    selectedServices = JSON.parse(selectedServicesStr);
  } catch (err) {
    console.warn('failed to parse selected services', selectedServicesStr, err);
    sessionStorage.removeItem('selected-refund-services');
    return redirect();
  }

  try {
    description = JSON.parse(descriptionStr);
  } catch (err) {
    console.warn('failed to parse description', descriptionStr, err);
    sessionStorage.removeItem('refund-description');
    return redirect();
  }

  if (selectedServices.length === 0) {
    return redirect();
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <s.PageContainer>
      <s.Icon />
      <RefundsDescription>
        <RichText content={description} />
      </RefundsDescription>
      <RefundsSeparator />
      {selectedServices.map((service) => (
        <RefundSection key={service.title} {...service} />
      ))}
      <FiveStarSurvey guideName={'RefundGuide'} />
    </s.PageContainer>
  );
};

export default RefundGuidePage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/subpages/RefundGuidePage/RefundGuidePage.tsx